import {ApolloClient} from '@apollo/client';
import {GET_ZIPCODE_LISTING, ZipcodeListResponse} from '../graphql/queries/getZipcodeListing';

/**
 * 后端 getZipcodeListing 单页上限（api-server PageRequestType.toPageRequest 中 MAX_PAGE_SIZE = 200），
 * size 超过该值会直接抛 "请求超限"。
 */
const ZIPCODE_QUERY_BATCH_SIZE = 200;

/**
 * 批量查询邮编的 isTakingDeliveryOrder 状态。
 *
 * 邮编按 200 个一批拆分请求（每批的邮编数 = 每页条数，保证一页即可取全），page 从 1 开始，
 * 所有批次并发请求后合并为 Map<zipcode, isTakingDeliveryOrder>。
 */
export const fetchZipcodeTakingStatus = async (
  client: ApolloClient<unknown>,
  zipcodes: string[],
): Promise<Map<string, boolean>> => {
  const uniqueZipcodes = Array.from(
    new Set(zipcodes.map(z => z?.trim()).filter((z): z is string => !!z)),
  );
  const statusMap = new Map<string, boolean>();
  if (uniqueZipcodes.length === 0) {
    return statusMap;
  }

  const batches: string[][] = [];
  for (let i = 0; i < uniqueZipcodes.length; i += ZIPCODE_QUERY_BATCH_SIZE) {
    batches.push(uniqueZipcodes.slice(i, i + ZIPCODE_QUERY_BATCH_SIZE));
  }

  const results = await Promise.all(
    batches.map(batch =>
      client.query<ZipcodeListResponse>({
        query: GET_ZIPCODE_LISTING,
        variables: {
          filters: {zipcode: batch.join(',')},
          pageRequest: {
            page: 1,
            size: ZIPCODE_QUERY_BATCH_SIZE,
            sortBy: 'zipcode',
            sortDirection: 'ASC',
          },
        },
        fetchPolicy: 'network-only',
      }),
    ),
  );

  results.forEach(({data}) => {
    data?.getZipcodeListing?.content?.forEach(zipcode => {
      statusMap.set(zipcode.zipcode, zipcode.isTakingDeliveryOrder);
    });
  });
  return statusMap;
};
